import styled from 'styled-components';
import { Grid } from 'styled-css-grid';

export const StyledGrid = styled(Grid)`
  margin: 10px;
`;
